import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import type { BankWireResultInfo, DepositPayload } from '../../../../../../types/Cashier';
import { CardType } from '../../../../../../types/cardType';
import BonusSummary from '../../../../../BonusSummary/BonusSummary';

import {
  TXTWCL_OkX_letXs_make_a_bank_transfer,
  TXTWCL_Your_bank_transfer
} from './BankTransfer.messages.json';
import { context } from './BankTransfer.scss';
import BankWire from './components/BankWire/BankWire';
import EnvoyLbt from './components/EnvoyLbt/EnvoyLbt';
import Multibanco from './components/Multibanco/Multibanco';

interface Props {
  deposit: DepositPayload;
  resultInfo: BankWireResultInfo;
}

const BankTransfer: React.FC<Props> = ({ deposit, resultInfo }) => {
  const { bankInfo, amount, currency, type } = deposit;

  const userEmail = useSelector(select.account.getEmail);
  return (
    <div className={context}>
      <BonusSummary />
      {type === CardType.Multibanco ? (
        <Translation tagName="h2" {...TXTWCL_Your_bank_transfer} />
      ) : (
        <Translation tagName="h2" {...TXTWCL_OkX_letXs_make_a_bank_transfer} />
      )}

      {type === CardType.EnvoyLbt && (
        <EnvoyLbt bankInfo={bankInfo} amount={amount} currency={currency} userEmail={userEmail} />
      )}
      {type === CardType.BankWire && <BankWire bankInfo={resultInfo} userEmail={userEmail} />}
      {type === CardType.Multibanco && (
        <Multibanco cardType={type} amount={amount} currency={currency} userEmail={userEmail} />
      )}
    </div>
  );
};

export default BankTransfer;
